import type { RaspadinhaCampaign } from '@/types/raspadinha-campaign'
import { ensureDateWinningSchedules } from './date-winning-schedules'

export function serializeRaspadinhaCampaignSnapshot(campaign: RaspadinhaCampaign): string {
  const normalized: RaspadinhaCampaign = {
    ...campaign,
    winning_date_schedules: ensureDateWinningSchedules(
      campaign.winning_date_schedules,
      campaign.starts_at,
      campaign.ends_at
    ),
  }

  return JSON.stringify(normalized)
}

export function hasRaspadinhaCampaignChanges(
  current: RaspadinhaCampaign,
  savedSnapshot: string
): boolean {
  return serializeRaspadinhaCampaignSnapshot(current) !== savedSnapshot
}
